import Validator from "./Validator";

export default class JsonEntitiesEntityDataCardContentRowsRowComponentsComponentContainerStyleValidator extends Validator {
    constructor() {
        super();
        this.validationRules = {
            type: 'object',
            empty: false,
            mandatory: false,
            attributes: {
                maxWidth: {
                    type: 'string',
                    empty: false,
                    mandatory: false
                },
                margin: {
                    type: 'string',
                    empty: false,
                    mandatory: false
                }
            }
        };
    }
}
